// @ts-strict-ignore
import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getBulkCapabilityValues, getCapabilityValue } from 'services/CapabilitiesService'
import {
  BulkCapabilityRequest,
  BulkCapabilityResponse,
  CapabilitiesRequest,
} from 'types/capabilities/capabilities'
import { QueryMetaType } from 'types/reactQuery'
import { TEN_MINUTES } from 'utils/utils'

export const useCapabiltiesQuery = (
  { group, name, scope, subjectId }: CapabilitiesRequest,
  enabled?: boolean
) => {
  const meta: QueryMetaType = {
    errorAdditionalData: { group, name, scope, subjectId },
    excludedErrorCodes: [404],
  }

  return useQuery({
    queryKey: reactQueryKeys.capabilities(group, name, scope, subjectId),
    queryFn: () => getCapabilityValue({ group, name, scope, subjectId }),
    enabled,
    meta,
    gcTime: TEN_MINUTES,
  })
}

export const useBulkCapabiltiesQuery = (
  request: BulkCapabilityRequest,
  isEnabled = false,
  queryHash?: string
) => {
  const meta: QueryMetaType = {
    errorAdditionalData: request,
    excludedErrorCodes: [404],
  }

  const isQueryEnabled = isEnabled

  return useQuery({
    queryKey: reactQueryKeys.bulkCapabilities(request, queryHash),
    queryFn: async () => {
      const data = await getBulkCapabilityValues(request)
      if (!!data) {
        return data
      }
      return {} as BulkCapabilityResponse
    },
    enabled: isQueryEnabled,
    meta,
    ...(queryHash && { queryHash }),
  })
}
